module.exports = __webpack_public_path__ + "img/logo1 (12).dd0647b9.jpg";